function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.99 511.99",
    style: {
      enableBackground: "new 0 0 511.99 511.99"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M37.845,272.751C-11.498,192.593,13.472,87.6,93.629,38.245s185.15-24.386,234.506,55.772  c16.983,27.575,25.749,59.424,25.286,91.808c-3.044,94.243-80.79,168.8-175.07,167.887H21.045l16.557-28.123  C47.463,309.372,47.549,289.052,37.845,272.751z",
    "data-original": "#FFFFFF",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEEDFF"
    },
    d: "M474.181,418.845c49.319-80.181,24.3-185.162-55.881-234.481  c-20.295-12.479-42.976-20.575-66.595-23.74c1.193,8.352,1.753,16.764,1.704,25.201c-3.044,94.243-80.79,168.8-175.07,167.887  h-17.775c13.903,84.662,87.328,146.63,173.122,146.094h157.295l-16.557-28.123C464.575,455.466,464.478,435.147,474.181,418.845z",
    "data-original": "#D1EEFF",
    className: "",
    "data-old_color": "#D1EEFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002856"
    },
    d: "M484.894,465.473c-7.463-12.357-7.463-27.819,0-40.176c52.837-85.904,26.041-198.384-59.862-251.221   c-18.992-11.688-39.969-19.796-61.883-23.923c-7.061-38.277-26.175-73.303-54.542-99.953   C271.122,14.334,220.049-3.709,168.356,0.65C67.807,8.527-7.31,96.415,0.567,196.964c2.277,29.134,11.517,57.293,26.942,82.117   c7.463,12.357,7.463,27.819,0,40.176l-16.923,28.245c-3.433,5.783-1.522,13.258,4.261,16.679c1.875,1.108,4.018,1.704,6.209,1.704   h129.537c19.114,85.477,95.034,146.204,182.618,146.094h157.782c6.72,0,12.175-5.454,12.175-12.175   c0-2.179-0.584-4.334-1.704-6.209L484.894,465.473z M42.35,341.537l5.844-9.861c12.15-20.1,12.15-45.277,0-65.377   C2.381,191.851,25.598,94.369,100.033,48.557s171.929-22.608,217.742,51.839c15.754,25.591,23.886,55.138,23.46,85.185   c-2.91,87.608-75.239,156.869-162.895,155.956H42.35z M333.687,487.631c-74.399,0.426-139.593-49.721-158.269-121.745h2.922   c100.927,0.84,184.079-79.049,187.244-179.94c0-3.531,0-7.061,0-10.592c85.1,19.978,137.889,105.151,117.91,190.251   c-3.884,16.533-10.397,32.323-19.297,46.787c-12.15,20.1-12.15,45.277,0,65.377l5.844,9.861H333.687z",
    "data-original": "#1AA8FF",
    className: "active-path",
    "data-old_color": "#1AA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002856"
    },
    d: "M196.48,153.927L196.48,153.927c0,12.175-11.444,19.966-40.785,21.184l-1.217,1.217l5.357,37.741   h24.349l2.557-14.244c24.836-4.383,44.924-16.557,44.924-46.385l0,0c0-30.923-22.766-48.698-56.368-48.698   c-21.805-0.524-42.696,8.717-56.977,25.201l21.427,23.497c8.9-9.995,21.561-15.827,34.941-16.07   C188.566,137.37,196.48,143.457,196.48,153.927z",
    "data-original": "#1AA8FF",
    className: "active-path",
    "data-old_color": "#1AA8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.164,
    y: 232.526,
    style: {
      fill: "#002856"
    },
    width: 37.741,
    height: 37.254,
    "data-original": "#1AA8FF",
    className: "active-path",
    "data-old_color": "#1AA8FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.41f2b8f58f52cfe268ce8ea038216bbb.svg";
export { ForwardRef as ReactComponent };